<template>
  <div class="p-6 bg-white rounded-lg">
    <div class="flex items-center mb-4 pb-4 border-b">
      <div
        class="w-12 h-12 rounded-lg text-white p-1 bg-tertiary"
      >
        <icon name="html_mailers" />
      </div>
      <h3 class="text-2xl font-medium ml-4 capitalize">
        {{ this.type }} Valuation Mailer
      </h3>
    </div>
    <div>
      <button
        class="mb-2 p-3 inline-block no-underline bg-secondary button-text-color text-center text-sm w-full rounded uppercase"
        @click="openMailer"
      >
        Send
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import api from '@/http'

export default {
  props: ['module'],

  computed: {
    ...mapState(['selectedOffice']),

    type () {
      return this.module.settings.type
    }
  },

  methods: {
    ...mapActions(['displayToastNotification']),

    openMailer () {
      let data = {
        type: this.type,
        office_id: this.selectedOffice.id
      }

      api.post('valuation-mailer', data)
        .then(response => {
          let newTab = window.open()
          newTab.location.href = response.data.url
        }).catch(() => {
          this.displayToastNotification({
            type: 'warning',
            icon: 'fa-bell',
            title: 'Unable to open valuation mailer',
            info: `We've been unable to redirect you to the ${this.type} valuation mailer, please try again later.`
          })
        })
    }
  }
}
</script>
